


































































































































































































import {
  computed,
  defineComponent,
  onMounted,
  ref
} from '@nuxtjs/composition-api';
import {
  SfModal
} from '@storefront-ui/vue';
import axios from 'axios';
import marked from 'marked';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import JetInput from '~/components/JetUi/atoms/Input/JetInput.vue';
import JetUiButton from '~/components/JetUi/atoms/JetUiButton/JetUiButton.vue';
import { useUiNotification } from "~/composables/useUiNotification";

interface PostForm {
  title: string;
  date: string;
  content: string;
  author: string;
  tags: string[];
  categories: string[];
  excerpt: string;
};

extend('required', {
  ...required,
  message: 'Este campo é obrigatório',
});

export default defineComponent({
  name: 'BlogForm',
  components: {
    ValidationProvider,
    ValidationObserver,
    JetInput,
    JetUiButton,
    SfModal,
  },
  setup() {
    const { send: sendNotification } = useUiNotification();

    const newTag = ref('');
    const newCategory = ref('');
    const loading = ref(true);
    const images = ref<File[]>([]);
    const isAuthorized = ref(false);
    const categories = ref([]);
    const userForm = ref({
      username: '',
      password: ''
    });
    const form = ref<PostForm>({
      title: '',
      date: '',
      content: '',
      author: "Marketing",
      tags: [],
      categories: [],
      excerpt: ''
    });

    const titleOriginality = ref(0);
    const iaTitleDetectionResult = ref(0);
    const iaContentDetectionResult = ref(0);
    const hiddenWebView = ref(null);
    const missingHeadings = ref<string[]>([]);

    const compiledMarkdown = computed(() => {
      if (!form.value.content) {
        return '<div>Veja um preview do markdown aqui</div>';
      }
      try {
        return marked(form.value.content);
      } catch (e) {
        console.error("Erro ao compilar Markdown:", e);
        return '<div>Erro ao renderizar o Markdown</div>';
      }
    });

    const sendForm = async (form: PostForm) => {
      try {
        const formData = new FormData();
        formData.append("textData", JSON.stringify(form));
        if (images.value.length > 0) {
          formData.append("image", images.value[0]);
        }

        const response = await fetch("/api/d669/70ad11b6", {
          method: "POST",
          body: formData
        });

        if (!response.ok) {
          sendNotification({
            icon: "error",
            id: Symbol(`post_error`),
            message: 'Erro ao criar post',
            persist: true,
            title: "post error",
            type: "danger",
          });
        } else {
          sendNotification({
            icon: "check",
            id: Symbol(`post_sucess`),
            message: 'Post criado com sucesso',
            persist: true,
            title: "post sucess",
            type: "success",
          });
        };
        window.location.href = "/blog";
      } catch (error) {
        console.error("Erro ao enviar:", error);
      }
    }

    const handleFileUpload = (event: Event) => {
      const target = event.target as HTMLInputElement;
      if (target.files) {
        images.value = Array.from(target.files)
      }
    };

    const addItem = (key: string, content: string) => {
      if (content && content.length > 0) {
        form.value[key].push(content);
        if (key === 'tags') {
          newTag.value = '';
        } else {
          newCategory.value = '';
        }
      }
    };

    const login = async () => {
      if (userForm.value) {
        try {
          const response = await axios.post("/api/login", { username: userForm.value.username, password: userForm.value.password });
          if (response.status === 200) {
            isAuthorized.value = true;
            sendNotification({
              icon: "check",
              id: Symbol(`login_sucess`),
              message: 'Login realizado com sucesso',
              persist: true,
              title: "login sucess",
              type: "success",
            });
          } else {
            sendNotification({
              icon: "error",
              id: Symbol(`login_error`),
              message: 'Erro ao realizar login',
              persist: true,
              title: "login error",
              type: "danger",
            });
          };
        }
        catch (error) {
          console.error(error);
          sendNotification({
            icon: "error",
            id: Symbol(`login_error`),
            message: 'Erro ao realizar login',
            persist: true,
            title: "login error",
            type: "danger",
          });
        }
      }
    };

    const removeItem = (key: string, index: number) => {
      form.value[key].splice(index, 1);
    };

    const applyFormat = (format: string) => {
      const textarea = document.querySelector('textarea');
      if (!textarea) return;

      const startPos = textarea.selectionStart;
      const endPos = textarea.selectionEnd;
      const selectedText = textarea.value.substring(startPos, endPos);

      let newText = '';
      switch (format) {
        case 'bold':
          newText = `**${selectedText}**`;
          break;
        case 'italic':
          newText = `*${selectedText}*`;
          break;
        case 'h1':
          newText = `# ${selectedText}`;
          break;
        case 'h2':
          newText = `## ${selectedText}`;
          break;
        case 'h3':
          newText = `### ${selectedText}`;
          break;
        case 'h4':
          newText = `#### ${selectedText}`;
          break;
        case 'h5':
          newText = `##### ${selectedText}`;
          break;
        case 'h6':
          newText = `###### ${selectedText}`;
          break;
        case 'link':
          const url = prompt('Insira o URL:');
          newText = url ? `[${selectedText}](${url})` : selectedText;
          break;
        case 'ul':
          newText = `- ${selectedText}`;
          break;
        case 'ol':
          newText = `1. ${selectedText}`;
          break;
        case 'quote':
          newText = `> ${selectedText}`;
          break;
        case 'code':
          newText = `\`\`\`\n${selectedText}\n\`\`\``;
          break;
        case 'image':
          const imageUrl = prompt('Insira o URL da imagem:');
          newText = imageUrl ? `![${selectedText}](${imageUrl})` : selectedText;
          break;
        default:
          newText = selectedText;
      }

      const textBefore = textarea.value.substring(0, startPos);
      const textAfter = textarea.value.substring(endPos);
      const updatedText = textBefore + newText + textAfter;

      form.value.content = updatedText;

      textarea.focus();
      textarea.selectionStart = startPos + newText.length;
      textarea.selectionEnd = startPos + newText.length;
    };

    const wordCount = computed(() => {
      return form.value.content.split(/\s+/).filter(word => word.length > 0).length;
    });



    const keywordDensity = computed(() => {
      const keyword = form.value.title.toLowerCase();
      const content = form.value.content.toLowerCase();
      const count = (content.split(keyword).length - 1);
      return wordCount.value > 0 ? ((count / wordCount.value) * 100).toFixed(2) : 0;
    });

    const keywordInFirstParagraph = computed(() => {
      const firstParagraph = form.value.content.split('\n')[0].toLowerCase();
      return firstParagraph.includes(form.value.title.toLowerCase());
    });

    const analyzeTitle = async (title) => {
      titleOriginality.value = await checkTitleOriginality(title);

      iaTitleDetectionResult.value = detectIaGeneratedContent(title);
    };

    const analyzeContent = async (content) => {
      iaContentDetectionResult.value = detectIaGeneratedContent(content);
    };

    const checkTitleOriginality = async (title): Promise<number> => {
      return new Promise((resolve) => {
        if (!hiddenWebView.value) {
          console.warn("WebView ainda não está carregado.");
          return resolve(50);
        }
        const webView = hiddenWebView.value;
        const searchUrl = `https://www.google.com/search?q=${encodeURIComponent(title)}`;

        webView.onload = () => {
          try {
            const searchResultsContainer = webView.contentDocument.getElementById('search');

            if (searchResultsContainer) {
              const approximateResultsElement = searchResultsContainer.querySelector('#result-stats');
              let approximateResultsCount = 0;

              if (approximateResultsElement) {
                const resultsText = approximateResultsElement.textContent;
                const match = resultsText.match(/Aproximadamente\s+([\d.]+)/i);
                if (match) {
                  approximateResultsCount = parseFloat(match[1].replace(/\./g, ''));
                }
              }

              const originality = Math.max(0, 100 - (Math.log10(approximateResultsCount + 1) * 15));

              resolve(originality);
            } else {
              console.warn("Container de resultados da busca não encontrado. Seletor desatualizado.");
              resolve(50);
            }
          } catch (error) {
            console.error("Erro ao analisar os resultados da busca:", error);
            resolve(50);
          }
        };
        webView.src = searchUrl;
      });
    };

    const detectIaGeneratedContent = (text: string) => {
    let score = 0;

    const wordCount = text.split(/\s+/).length;
    if (wordCount > 15) {
        score += 12;
    }

    const words = text.toLowerCase().split(/\s+/);
    const wordCounts = {};
    words.forEach(word => {
        wordCounts[word] = (wordCounts[word] || 0) + 1;
    });
    for (const word in wordCounts) {
        if (wordCounts[word] > 2) {
            score += 8;
        }
    }

    const clichePatterns = [
        { pattern: /em resumo/i, weight: 15 },
        { pattern: /em conclusão/i, weight: 15 },
        { pattern: /de acordo com/i, weight: 10 },
        { pattern: /neste artigo/i, weight: 8 },
        { pattern: /inteligência artificial/i, weight: 5 },
        { pattern: /linguagem natural/i, weight: 5 },
        { pattern: /machine learning/i, weight: 5 },
        { pattern: /otimizar a experiência do usuário/i, weight: 7 },
        { pattern: /a fim de/i, weight: 6 },
        { pattern: /é importante notar/i, weight: 9 },
        { pattern: /com o objetivo de/i, weight: 8 },
        { pattern: /no mundo de hoje/i, weight: 7 },
    ];
    clichePatterns.forEach(pattern => {
        if (pattern.pattern.test(text)) {
            score += pattern.weight;
        }
    });

    const genericWords = ["isso", "este", "artigo", "conteúdo", "aborda", "maneira", "aspecto", "ferramenta", "solução", "coisa", "elemento"];
    let genericScore = 0;
    genericWords.forEach(word => {
        if (text.toLowerCase().includes(word)) {
            genericScore += 3;
        }
    });
    score += genericScore;

    const sentenceCount = text.split(/[.?!]/).length;
    const averageWordsPerSentence = wordCount / sentenceCount;
    if (averageWordsPerSentence > 25) {
        score += 10;
    }

    score = Math.min(score, 100);

    return score;
};

    const onWebViewLoad = () => {
      hiddenWebView.value = document.querySelector('iframe[ref="hiddenWebView"]');

       updateMissingHeadings();
    };

    const updateMissingHeadings = () => {
      const content = form.value.content;
      const hasH1 = !!content.match(/^#\s/m);
      const hasH2 = !!content.match(/^##\s/m);
      const hasH3 = !!content.match(/^###\s/m);
      const hasH4 = !!content.match(/^####\s/m);
      const hasH5 = !!content.match(/^#####\s/m);
      const hasH6 = !!content.match(/^######\s/m);

      const missing: string[] = [];
      if (!hasH1) missing.push("H1");
      if (!hasH2) missing.push("H2");
      if (!hasH3) missing.push("H3");
      if (!hasH4) missing.push("H4");
      if (!hasH5) missing.push("H5");
      if (!hasH6) missing.push("H6");

      missingHeadings.value = missing;
    };

    onMounted(async () => {
      try {
        const response = await axios.get("/api/posts/");
        const postArray = response.data;

        categories.value = [...new Set(postArray.flatMap((obj) => obj.categories))];
      } catch (error) {
        console.error("Erro ao carregar:", error);
      }
      loading.value = false;

      updateMissingHeadings();
    });

    return {
      loading,
      form,
      compiledMarkdown,
      handleFileUpload,
      sendForm,
      newTag,
      newCategory,
      addItem,
      removeItem,
      isAuthorized,
      userForm,
      login,
      categories,
      applyFormat,
      wordCount,
      keywordDensity,
      keywordInFirstParagraph,
      titleOriginality,
      iaTitleDetectionResult,
      iaContentDetectionResult,
      analyzeTitle,
      analyzeContent,
      hiddenWebView,
      onWebViewLoad,
      missingHeadings,
      updateMissingHeadings
    }
  }
});
